<template>
  <section class="honors-section">
    <!-- Stage Background Effect -->
    <div class="stage-bg">
      <div class="ring ring-1"></div>
      <div class="ring ring-2"></div>
      <div class="ring ring-3"></div>
      <div class="glow"></div>
    </div>

    <div class="container">
      <!-- Section Header -->
      <div class="section-header">
        <div class="title-wrapper">
          <div class="decor-diamond"></div>
          <h2 class="section-title">资质荣誉</h2>
          <div class="decor-diamond"></div>
        </div>
        <p class="section-subtitle">
          权威认证 · 专业保障 · 值得信赖
        </p>
      </div>

      <!-- Honors Grid -->
      <div class="honors-grid">
        <!-- Row 1 (5 items) -->
        <div class="honors-row row-5">
          <div class="honor-card" v-for="item in row1" :key="item.id">
            <div class="icon-wrapper">
              <img :src="item.img" :alt="item.title" @error="handleImageError" />
            </div>
            <div class="card-content">
              <h3 class="card-title">{{ item.title }}</h3>
              <p class="card-desc">{{ item.desc }}</p>
              <div class="card-decor">
                <div class="line"></div>
                <div class="dot"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2 (4 items) -->
        <div class="honors-row row-4">
          <div class="honor-card" v-for="item in row2" :key="item.id">
            <div class="icon-wrapper">
              <img :src="item.img" :alt="item.title" @error="handleImageError" />
            </div>
            <div class="card-content">
              <h3 class="card-title">{{ item.title }}</h3>
              <p class="card-desc">{{ item.desc }}</p>
              <div class="card-decor">
                <div class="line"></div>
                <div class="dot"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HonorsSection',
  data() {
    return {
      row1: [
        { id: 5, img: require('../assets/HonorsSection/5.png'), title: '腾讯安全iOA', desc: '授权合作伙伴' },
        { id: 4, img: require('../assets/HonorsSection/4.png'), title: '腾讯云', desc: '授权合作伙伴' },
        { id: 1, img: require('../assets/HonorsSection/1.png'), title: '企业微信', desc: '私有化部署运维授权服务商' },
        { id: 2, img: require('../assets/HonorsSection/2.png'), title: '企业微信', desc: '定制开发服务商' },
        { id: 3, img: require('../assets/HonorsSection/3.png'), title: '企业微信', desc: '合作推广服务商' }
      ],
      row2: [
        { id: 6, img: require('../assets/HonorsSection/6.png'), title: 'ISO/IEC 27001', desc: '信息安全管理体系认证' },
        { id: 7, img: require('../assets/HonorsSection/7.png'), title: 'ISO 9001', desc: '质量管理体系认证' },
        { id: 8, img: require('../assets/HonorsSection/8.png'), title: '企业服务中台', desc: '软件著作权' },
        { id: 9, img: require('../assets/HonorsSection/9.png'), title: '质量服务信誉', desc: 'AAA 企业' }
      ]
    }
  },
  methods: {
    handleImageError(e) {
      // 临时 SVG 占位图，带麦穗装饰效果
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
          <path d="M10,60 Q10,100 60,110 Q110,100 110,60" fill="none" stroke="%23e4ecf7" stroke-width="4" stroke-linecap="round"/>
          <path d="M15,65 L25,55 L20,75 Z M105,65 L95,55 L100,75 Z" fill="%23e4ecf7"/>
          <circle cx="60" cy="50" r="30" fill="%230052d9" opacity="0.8"/>
          <path d="M50,50 L58,58 L75,40" fill="none" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
      e.target.src = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
    }
  }
}
</script>

<style scoped>
.honors-section {
  padding: 80px 0 120px;
  background-color: #f4f8ff;
  background-image: url('../assets/HonorsSection/bg.png');
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

/* Stage Background Effect */
.stage-bg {
  position: absolute;
  bottom: -150px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  z-index: 0;
}

.ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(0, 82, 217, 0.15);
  box-shadow: inset 0 0 20px rgba(0, 82, 217, 0.05), 0 0 20px rgba(0, 82, 217, 0.05);
}

.ring-1 {
  width: 1800px;
  height: 400px;
  border-width: 2px;
}

.ring-2 {
  width: 1400px;
  height: 300px;
  border-width: 3px;
  border-color: rgba(0, 82, 217, 0.2);
}

.ring-3 {
  width: 1000px;
  height: 200px;
  border-width: 4px;
  border-color: rgba(0, 82, 217, 0.3);
  background: radial-gradient(ellipse at center, rgba(255,255,255,0.6) 0%, rgba(244,248,255,0) 70%);
}

.glow {
  position: absolute;
  width: 800px;
  height: 150px;
  background: radial-gradient(ellipse at center, rgba(0, 82, 217, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(20px);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 40px);
  position: relative;
  z-index: 1;
}

/* Header Styles */
.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 12px;
}

.decor-diamond {
  width: 8px;
  height: 8px;
  background-color: #0052d9;
  transform: rotate(45deg);
  position: relative;
}

.decor-diamond::before,
.decor-diamond::after {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 1px;
  width: 40px;
  background: linear-gradient(to right, #0052d9, transparent);
}

.title-wrapper .decor-diamond:first-child::before {
  display: none;
}
.title-wrapper .decor-diamond:first-child::after {
  right: 12px;
  background: linear-gradient(to left, rgba(0, 82, 217, 0.5), transparent);
}

.title-wrapper .decor-diamond:last-child::after {
  display: none;
}
.title-wrapper .decor-diamond:last-child::before {
  left: 12px;
  background: linear-gradient(to right, rgba(0, 82, 217, 0.5), transparent);
}

.section-title {
  font-size: clamp(24px, 3vw, 36px);
  color: #111;
  font-weight: 800;
  letter-spacing: 2px;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
  letter-spacing: 1px;
}

/* Honors Grid */
.honors-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.honors-row {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

/* Card Styles */
.honor-card {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 30px 20px 24px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 82, 217, 0.04);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 1px solid rgba(255, 255, 255, 0.8);
  flex: 1 1 200px;
  max-width: 260px;
  min-width: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.honor-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 82, 217, 0.04), transparent);
  transition: left 0.6s ease;
  pointer-events: none;
}

.honor-card:hover::before {
  left: 100%;
}

.honor-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 82, 217, 0.1);
}

.icon-wrapper {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.honor-card:hover .icon-wrapper img {
  transform: scale(1.08);
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.card-title {
  font-size: 16px;
  color: #111;
  font-weight: 700;
  margin-bottom: 8px;
}

.card-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin: 0;
  margin-bottom: 16px;
}

.card-decor {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: auto;
}

.card-decor .line {
  width: 20px;
  height: 2px;
  background-color: #0052d9;
  border-radius: 1px;
}

.card-decor .dot {
  width: 4px;
  height: 4px;
  background-color: #0052d9;
  border-radius: 50%;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .honor-card {
    max-width: calc(33.333% - 16px);
  }
}

@media (max-width: 768px) {
  .honor-card {
    max-width: calc(50% - 12px);
  }
  .stage-bg {
    display: none;
  }
  .honors-section {
    padding: 60px 0 80px;
  }
}

@media (max-width: 480px) {
  .honors-section {
    padding: 48px 0 60px;
  }
  .section-header {
    margin-bottom: 36px;
  }
  .honor-card {
    max-width: 100%;
    flex: 1 1 100%;
    padding: 24px 16px 20px;
  }
  .honors-row {
    gap: 12px;
  }
  .icon-wrapper {
    width: 80px;
    height: 80px;
    margin-bottom: 14px;
  }
  .card-title {
    font-size: 14px;
  }
  .card-desc {
    font-size: 12px;
  }
}
</style>